(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('launch-object-test', {
                parent: 'testing',
                url: '/launch-object-test/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.launchObjectTest.home.automatic.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/launch-object-test/launch-object-test.html',
                        controller: 'LaunchObjectTestController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: {
                        value: null,
                        squash: true
                    }
                },
                resolve: {
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('launchObjectTest');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('launch-object-test.manual', {
                parent: 'testing',
                url: '/launch-object-test-manual/{id}',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.launchObjectTest.home.manual.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/launch-object-test/launch-object-test-manual.html',
                        controller: 'LaunchObjectTestManualController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: {
                        value: null,
                        squash: true
                    }
                },
                resolve: {
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('launchObjectTest');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('objectTestResult');

                        return $translate.refresh();
                    }],
                }
            })
            .state('launch-object-test.view', {
                parent: 'launch-object-test',
                url: '/results',
                data: {
                    authorities: ['ROLE_DOMAIN_USER'],
                    pageTitle: 'jotApp.launchObjectTest.home.runResults.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/launch-object-test/launch-object-test-view.html',
                        controller: 'LaunchObjectTestViewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: {
                        value: null,
                        squash: true
                    },
                    testResults: {
                        value: []
                    }
                },
                resolve: {
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }],
                    testResults: ['$stateParams', function ($stateParams) {
                        return $stateParams.testResults;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('launchObjectTest');
                        $translatePartialLoader.addPart('testSchedule');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                }
            });
    }

})();
